import { Colors } from '@thoughtspot/radiant-react/widgets/typography/typography';
import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createChartColumnNumberFormatter, createChartConditionalFormatter, createColumnNameTextInput, createCompactHeadersCheckbox, createDisplayValueFormatDropdown, createDisplayValuesRadioGroup, createHeatmapModeCheckbox, createShowSubtotalsCheckboxGroup, createShowTotalsCheckboxGroup, createTimeBucketDropdown, createTotalsPositionRadioGroup, } from '../schema-composer-utils/common-elements';
import { shouldDisablePivotConditionalFormatter, shouldHidePivotConditionalFormatter, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createChartConditionalFormatter({
                                        isDisabledCallback: shouldDisablePivotConditionalFormatter,
                                        isHiddenCallback: shouldHidePivotConditionalFormatter,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createAggregationDropdown(),
                                    createChartConditionalFormatter({
                                        isDisabledCallback: shouldDisablePivotConditionalFormatter,
                                        isHiddenCallback: shouldHidePivotConditionalFormatter,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const displaySettings = [
    createSection({
        properties: {
            label: 'chart.chartEditor.chartConfigurator.VALUES_SECTION',
            labelVariant: 'p-small-bold',
            labelColor: Colors.grayLight,
            showDivider: false,
        },
        children: [
            createDisplayValuesRadioGroup(),
            createDisplayValueFormatDropdown(),
        ],
        translate: ['label'],
    }),
    createSection({
        properties: {
            label: 'chart.chartEditor.chartConfigurator.SUMMARY_SECTION',
            labelVariant: 'p-small-bold',
            labelColor: Colors.grayLight,
            showDivider: false,
        },
        children: [
            createCompactHeadersCheckbox(),
            createShowSubtotalsCheckboxGroup(),
            createShowTotalsCheckboxGroup(),
            createTotalsPositionRadioGroup(),
        ],
        translate: ['label'],
    }),
    createSection({
        properties: {
            label: 'PRESENTATION',
            labelVariant: 'p-small-bold',
            labelColor: Colors.grayLight,
            showDivider: false,
        },
        children: [createHeatmapModeCheckbox()],
        translate: ['label'],
    }),
];
export const pivotTableSettingsSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: null,
    [ChartSettingsV2MenuItems.DATA_LABEL]: null,
    [ChartSettingsV2MenuItems.TOOLTIP]: null,
    [ChartSettingsV2MenuItems.LEGEND]: null,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=pivot-schema.js.map